import 'bootstrap/dist/css/bootstrap.min.css'
import Routers from './Router/Router'
import './assets/css/contact-us.css'
import { useState } from 'react'
import { CgClose } from 'react-icons/cg'

function App() {
  const [open, setOpen] = useState(false)

  return (
    <>
      <div>
        <div
          className='contact-us-text'
          style={{
            right: open ? '250px' : '0',
          }}
          onClick={() => setOpen((prev) => !prev)}
        >
          <p style={{ margin: 0, padding: 0 }}>CONTACT US</p>
        </div>
        <div
          className='contact-us-container'
          style={{
            width: '250px',
            display: open ? 'block' : 'none',
          }}
        >
          <span
            onClick={() => setOpen(false)}
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              cursor: 'pointer',
              padding: 10,
            }}
          >
            <CgClose fontSize={18} />
          </span>
          <p>
            <b>Email:</b> rsupport@seedingbrains.com
          </p>
          <hr />
          <p>
            <b>Contact No:</b> 9696857675, <br />
            <span>+971 505383739</span>
          </p>
          <hr />
          <p>
            <b>Address:</b> Seeding Brains Education and Training Computer
            Software Office 170 C Unique Business Center, Al-Karama, UAE PO Box:
            887556
          </p>
        </div>
      </div>
      <Routers />
    </>
  )
}

export default App
